import React, { useState } from "react";
import {
  IRateCourse,
  IRateCourseData,
} from "../../../../models/student/studentCourceDetail";
import { getAlertData, alertConstants } from "../../../../helper/sweet-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import { createStudentCourseRate } from "../../../../action/student/studentRateCourseActionCreator";
import LoaderSpinner from "../../../../common-components/loader";
import { Rating } from "react-simple-star-rating";
import { validateFields } from "../../../../helper/joi-validation";
import Joi from "joi";

const RateTheCourse = (props: IRateCourse) => {
  const {
    setShowRateCourse,
    createData,
    courseId,
    name,
    courseRate,
    getCourseRateDetails,
  } = props;

  const initialData: IRateCourseData = {
    rating: null,
    additionalReview: "",
    name: name,
    courseId: courseId,
  };

  const [data, setData] = useState(initialData);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<any>(undefined);

  const onChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    errors && delete errors[event.target.name];
    if (event.target.name === "rating") {
      setData({ ...data, rating: Number(event.target.value) });
    } else if (event.target.name === "additionalReview") {
      setData({ ...data, additionalReview: event.target.value });
    }
  };

  const onSubmit = () => {
    setShowRateCourse(false);
  };

  const schema = Joi.object().keys({
    rating: Joi.number().min(1).max(5).required().label("Please provide a valid rating"),
  });

  const onSave = () => {
    const validationErrors = validateFields(data, schema);
    if (validationErrors === undefined) {
      setLoading(true);
      createData(data, (type: string) => {
        setLoading(false);
        setAlert(type);
        if (type === alertConstants.success) {
          getCourseRateDetails(courseId);
        }
      });
    }
    else {
      setErrors(validationErrors);
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else {
      setShowRateCourse(false);
    }
  };

  const getPercentage = (count: number) => {
    if (!courseRate?.totalReviews) return 0;
    return (count / courseRate.totalReviews) * 100;
  };

  return (
    <>
      <div className="modal-body">
        <div className="rating d-flex py-3">
          <div className="rate-progress">
            <div className="rate-value">
              {[5, 4, 3, 2, 1].map((star) => (
                <span key={star}>{star}</span>
              ))}
            </div>
            {courseRate?.ratingDistribution &&
              [...courseRate.ratingDistribution]
                .reverse()
                .map((count, index) => (
                  <div className="rate-progress-bar" key={index}>
                    <div
                      className="progress-bar"
                      style={{ width: `${getPercentage(count)}%` }}
                    ></div>
                  </div>
                ))}
          </div>
          <div className="rate-dtls">
            <h2>{courseRate?.averageRating}</h2>
            <div>
              <Rating
                initialValue={courseRate?.averageRating || 0}
                size={20}
                readonly={true}
                allowFraction={true}
                fillColor="#948256"
              />
            </div>
            <p>
              <span>{courseRate?.totalReviews}</span> Reviews
            </p>
          </div>
        </div>
        <h2 className="mt-3">Provide your rating</h2>
        <p>
          Click on a star to change your rating 1 - 5, where 5 = Great! and 1 =
          Very Bad.
        </p>
        <div className="ratings mb-3">
          <div className="star-rating">
            {[5, 4, 3, 2, 1].map((star) => (
              <React.Fragment key={star}>
                <input
                  type="radio"
                  id={`${star}-stars`}
                  name="rating"
                  value={star}
                  checked={data.rating === star}
                  onChange={onChange}
                />
                <label htmlFor={`${star}-stars`} className="star">
                  &#9733;
                </label>
              </React.Fragment>
            ))}
          </div>
          {errors?.rating && (
            <div className="text-danger">{errors.rating}</div>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="review">Provide Additional Review</label>
          <textarea
            id="review"
            name="additionalReview"
            value={data.additionalReview}
            onChange={onChange}
            className="form-control"
          ></textarea>
        </div>
      </div>
      <div className="modal-footer mb-2">
        <button type="button" className="btn btn-primary" onClick={onSave}>
          Submit
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={onSubmit}
        >
          Cancel
        </button>
      </div>
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
      {loading && <LoaderSpinner />}
    </>
  );
};

const mapDispatchToProps = {
  createData: (data: any, callBack: Function) =>
    createStudentCourseRate(data, callBack),
};

function mapStateToProps(state: any) {
  return {
    courseRate: state.studentCourceRateDetail.rateDetail,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RateTheCourse);
